var Button = require('react-bootstrap').Button;
var React = require('react');

var ClientServiceEmailActions = require('../../actions/ClientServiceEmailActions');
var ClientServiceEmailForm = require('../ClientServiceEmail/Form');
var ClientServiceEmailStore = require('../../stores/ClientServiceEmailStore');
var ClientServiceEmailTable = require('../ClientServiceEmail/Table');
var Loading = require('../Loading');

var Email = React.createClass({
    propTypes: {
        readOnly: React.PropTypes.bool.isRequired,
        service: React.PropTypes.object.isRequired
    },
    componentDidMount: function () {
        // Need to signal for data here.
        ClientServiceEmailStore.addChangeListener(this._update);
    },
    componentWillUnmount: function () {
        ClientServiceEmailStore.removeChangeListener(this._update);
    },
    getInitialState: function () {
        var state = this.getStateFromStore();

        state.showDelete = null;
        state.showNew = false;
        state.showPassword = null;

        return state;
    },
    getStateFromStore: function () {
        return {
            emails: ClientServiceEmailStore.getEmailsForService(this.props.service.id),
            loading: ClientServiceEmailStore.loading(),
            violations: ClientServiceEmailStore.violations()
        };
    },
    render: function () {
        var service = this.props.service;
        var hostedMail = service.hosted_mail;
        var remaining = hostedMail.mailboxes - hostedMail.addresses.length;

        var buttonAttr = {
            disabled: !remaining || this.props.readOnly,
            bsStyle: 'success',
            bsSize: 'xsmall',
            onClick: this._handleButtonClick.bind(null, 'new', null)
        };
        var button = <Button {...buttonAttr}>Add email</Button>;

        var extras = [];
        var icon;
        if (this.state.showNew) {
            icon = this.state.loading ?
                <Loading message="" /> :
                <i className="fa fa-plus"></i>;

            extras.push(<ClientServiceEmailForm
                key="new"
                ref="form"
                cancelHandler={this._handleButtonClick.bind(null, 'cancel', null)}
                emailSuffix={hostedMail.domain}
                errors={this.state.violations}
                submitButtonText={<span>{icon} Create Email</span>}
                submitHandler={this._handleFormSubmit.bind(null, 'new', null)}
            />);
        } else if (this.state.showPassword) {
            icon = this.state.loading ?
                <Loading message="" /> :
                <i className="fa fa-check"></i>;

            extras.push(<ClientServiceEmailForm
                key="password"
                ref="form"
                cancelHandler={this._handleButtonClick.bind(null, 'cancel', null)}
                emailAddress={this.state.showPassword}
                errors={this.state.violations}
                submitButtonText={<span>{icon} Update Password</span>}
                submitHandler={this._handleFormSubmit.bind(null, 'password', this.state.showPassword)}
            />);
        } else if (this.state.showDelete) {
            icon = this.state.loading ?
                <Loading message="" /> :
                <i className="fa fa-times"></i>;

            extras.push(<ClientServiceEmailForm
                key="delete"
                ref="form"
                cancelButtonClasses={{ btn:true, "btn-default": true }}
                cancelHandler={this._handleButtonClick.bind(null, 'cancel', null)}
                emailAddress={this.state.showDelete}
                errors={this.state.violations}
                showPassword={false}
                submitButtonClasses={{ btn: true, "btn-danger": true }}
                submitButtonText={<span>{icon} Delete</span>}
                submitHandler={this._handleFormSubmit.bind(null, 'delete', this.state.showDelete)}
            />);
        }

        return <section>
            <p>
                Your service comes with {hostedMail.mailboxes} mailboxes for
                the <b>{hostedMail.domain}</b> domain. You have {remaining} remaining
                mailboxes.
            </p>

            <ClientServiceEmailTable emails={this.state.emails} loading={this.state.loading}
                 footerButtons={button} readOnly={this.props.readOnly} clickHandler={this._handleButtonClick} />

            {extras}
        </section>;
    },
    _handleButtonClick: function (action, email, e) {
        if (this.props.readOnly) {
            return
        }
        switch (action) {
            case 'cancel':
                this.setState(this.getInitialState());
                break;

            case 'new':
                this.setState({
                    showDelete: null,
                    showNew: true,
                    showPassword: null
                });
                break;

            case 'password':
                this.setState({
                    showDelete: null,
                    showNew: false,
                    showPassword: email
                });
                break;

            case 'delete':
                this.setState({
                    showDelete: email,
                    showNew: false,
                    showPassword: null
                });
                break;

            default:
                throw new Error("Unknown button action: " + action);
        }
    },
    _handleFormSubmit: function (action, email, e, data) {
        var promise;

        switch (action) {
            case 'delete':
                promise = ClientServiceEmailActions.deleteEmail(this.props.service, email);
                break;

            case 'new':
                promise = ClientServiceEmailActions.createEmail(this.props.service, data.email, data.password);
                break;

            case 'password':
                promise = ClientServiceEmailActions.changePassword(this.props.service, email, data.password);
                break;

            default:
                throw new Error("Unknown form action: " + action);
        }

        promise
            .then(() => this.setState(this.getInitialState()))
            .done();
    },
    _update: function () {
        this.setState(this.getStateFromStore());
    }
})
module.exports = Email;



// WEBPACK FOOTER //
// ./app/components/ClientService/Email.js